import { render, staticRenderFns } from "./Parametritation.vue?vue&type=template&id=076b8164&"
import script from "./Parametritation.vue?vue&type=script&lang=js&"
export * from "./Parametritation.vue?vue&type=script&lang=js&"
import style0 from "./Parametritation.vue?vue&type=style&index=0&id=076b8164&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports